import { createSelector } from '@reduxjs/toolkit';
import getIn from 'transmute/getIn';
import { getWidgetUiState } from './getWidgetUiState';
export const getUserInteractedWithWidget = createSelector([getWidgetUiState], getIn(['userInteractedWithWidget']));